// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar styles */
[data-sidebar="sidebar"] {
  --sidebar-width: 16rem;
  --sidebar-width-icon: 3rem;
}

/* Mobile sidebar width */
@media (max-width: 768px) {
  [data-sidebar="sidebar"][data-mobile="true"] {
    --sidebar-width: 18rem;
  }
}

/* Sidebar animations */
.group[data-state="collapsed"] {
  --sidebar-width: var(--sidebar-width-icon);
}

/* Smooth transitions for sidebar */
[data-sidebar="sidebar"] {
  transition: width 200ms ease;
}

/* Sidebar rail hover effect */
[data-sidebar="rail"]:hover::after {
  background-color: hsl(var(--sidebar-border));
}

/* Menu button active state */
[data-sidebar="menu-button"][data-active="true"] {
  background-color: hsl(var(--sidebar-accent));
  color: hsl(var(--sidebar-accent-foreground));
  font-weight: 500;
}

/* Collapsed state adjustments */
.group[data-collapsible="icon"] [data-sidebar="group-label"],
.group[data-collapsible="icon"] [data-sidebar="menu-badge"],
.group[data-collapsible="icon"] [data-sidebar="menu-action"] {
  opacity: 0;
  pointer-events: none;
}

/* Ensure proper spacing in collapsed mode */
.group[data-collapsible="icon"] [data-sidebar="menu-button"] {
  justify-content: center;
}

/* Sidebar inset adjustments */
.peer-data-[variant="inset"]:has(+ [data-sidebar="inset"]) {
  padding: 0.5rem;
}

/* Custom scrollbar for sidebar */
[data-sidebar="sidebar"] ::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}

[data-sidebar="sidebar"] ::-webkit-scrollbar-track {
  background: transparent;
}

[data-sidebar="sidebar"] ::-webkit-scrollbar-thumb {
  background-color: hsl(var(--sidebar-border));
  border-radius: 0.25rem;
}

[data-sidebar="sidebar"] ::-webkit-scrollbar-thumb:hover {
  background-color: hsl(var(--sidebar-foreground) / 0.3);
}`, "",{"version":3,"sources":["webpack://./src/styles/sidebar.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA,uBAAuB;AACvB;EACE,0CAA0C;AAC5C;;AAEA,mCAAmC;AACnC;EACE,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,4CAA4C;AAC9C;;AAEA,6BAA6B;AAC7B;EACE,4CAA4C;EAC5C,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;;;EAGE,UAAU;EACV,oBAAoB;AACtB;;AAEA,4CAA4C;AAC5C;EACE,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,sDAAsD;AACxD","sourcesContent":["/* Sidebar styles */\n[data-sidebar=\"sidebar\"] {\n  --sidebar-width: 16rem;\n  --sidebar-width-icon: 3rem;\n}\n\n/* Mobile sidebar width */\n@media (max-width: 768px) {\n  [data-sidebar=\"sidebar\"][data-mobile=\"true\"] {\n    --sidebar-width: 18rem;\n  }\n}\n\n/* Sidebar animations */\n.group[data-state=\"collapsed\"] {\n  --sidebar-width: var(--sidebar-width-icon);\n}\n\n/* Smooth transitions for sidebar */\n[data-sidebar=\"sidebar\"] {\n  transition: width 200ms ease;\n}\n\n/* Sidebar rail hover effect */\n[data-sidebar=\"rail\"]:hover::after {\n  background-color: hsl(var(--sidebar-border));\n}\n\n/* Menu button active state */\n[data-sidebar=\"menu-button\"][data-active=\"true\"] {\n  background-color: hsl(var(--sidebar-accent));\n  color: hsl(var(--sidebar-accent-foreground));\n  font-weight: 500;\n}\n\n/* Collapsed state adjustments */\n.group[data-collapsible=\"icon\"] [data-sidebar=\"group-label\"],\n.group[data-collapsible=\"icon\"] [data-sidebar=\"menu-badge\"],\n.group[data-collapsible=\"icon\"] [data-sidebar=\"menu-action\"] {\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Ensure proper spacing in collapsed mode */\n.group[data-collapsible=\"icon\"] [data-sidebar=\"menu-button\"] {\n  justify-content: center;\n}\n\n/* Sidebar inset adjustments */\n.peer-data-[variant=\"inset\"]:has(+ [data-sidebar=\"inset\"]) {\n  padding: 0.5rem;\n}\n\n/* Custom scrollbar for sidebar */\n[data-sidebar=\"sidebar\"] ::-webkit-scrollbar {\n  width: 0.5rem;\n  height: 0.5rem;\n}\n\n[data-sidebar=\"sidebar\"] ::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n[data-sidebar=\"sidebar\"] ::-webkit-scrollbar-thumb {\n  background-color: hsl(var(--sidebar-border));\n  border-radius: 0.25rem;\n}\n\n[data-sidebar=\"sidebar\"] ::-webkit-scrollbar-thumb:hover {\n  background-color: hsl(var(--sidebar-foreground) / 0.3);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
